import { useEffect, useState } from 'react'

export function useHiddenOnScroll(componentClassName: string) {
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    function observerCallback(entries: IntersectionObserverEntry[]) {
      entries.forEach(entry => setHidden(!entry.isIntersecting))
    }

    const targetElement = document.querySelector(`.${componentClassName}`)
    const observer = new IntersectionObserver(observerCallback, { threshold: 0 })

    if (targetElement) observer.observe(targetElement)

    return () => observer.disconnect()
  }, [componentClassName])

  return { hidden }
}
